/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimantRequiredDataResponseDto } from '../models/clm-claimant-required-data-response-dto';


/**
 * the ClaQueryClaimantData API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryClaimantDataService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdClaimantGet
   */
  static readonly ClaimClaimIdClaimantGetPath = '/claim/{claimId}/claimant';

  /**
   * Get claimant data which are needed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdClaimantGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdClaimantGet$Response(params: {
    claimId: string;
    'X-Authorization'?: string;
    language?: 'PL' | 'DE' | 'EN';
    caller?: 'FEC' | 'API' | 'FECFNOL';
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmClaimantRequiredDataResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryClaimantDataService.ClaimClaimIdClaimantGetPath, 'get');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
      rb.query('language', params.language, {});
      rb.query('caller', params.caller, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmClaimantRequiredDataResponseDto>;
      })
    );
  }

  /**
   * Get claimant data which are needed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdClaimantGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdClaimantGet(params: {
    claimId: string;
    'X-Authorization'?: string;
    language?: 'PL' | 'DE' | 'EN';
    caller?: 'FEC' | 'API' | 'FECFNOL';
  },
  context?: HttpContext

): Observable<ClmClaimantRequiredDataResponseDto> {

    return this.claimClaimIdClaimantGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmClaimantRequiredDataResponseDto>) => r.body as ClmClaimantRequiredDataResponseDto)
    );
  }

}
